import { useState, useEffect } from "react";
import { getGeneratedComments } from "@infrastructure/Services/GeneratedCommentsService";
import { GPTCommentSuggestionListType } from "../ContentSuggestion.types";

export function useContentGenerationForPost(
    postId: number | undefined,
    allowContentGeneration: boolean,
): {
    GPTCommentSuggestionList: GPTCommentSuggestionListType | undefined;
    loading: boolean;
} {
    const [GPTCommentSuggestionList, setGPTCommentSuggestionList] = useState<
        GPTCommentSuggestionListType | undefined
    >(undefined);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!postId) {
            return;
        }

        if (allowContentGeneration) {
            setLoading(true);
        } else {
            return;
        }

        (async () => {
            try {
                const newSuggestionResult = await getGeneratedComments(
                    String(postId),
                );
                setGPTCommentSuggestionList(newSuggestionResult);
            } catch {
                setGPTCommentSuggestionList(undefined);
            } finally {
                setLoading(false);
            }
        })();
    }, [postId, allowContentGeneration]);

    return { GPTCommentSuggestionList, loading };
}
